import { FC } from 'react';

/**
 * Renders a truly empty cell on the Change history table.
 * Usually en empty cell is represented with the placeholder '-' content,
 * but in some cases a truly empty cell is needed instead.
 * @constructor
 */
export const EmptyCell: FC = () => null;
